<template>
    <v-menu>
        <template v-slot:activator="{ on }">
            <v-btn
                    dark
                    icon
                    v-on="on"
            >
                <v-icon>fa-ellipsis-v</v-icon>
            </v-btn>
        </template>
        <v-list>
            <slot></slot>
            <v-list-tile v-if="equipment&&fault"  @click="$router.push({path: '/fault',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment:equipment}})">
                <v-list-tile-title>{{'View faults for'|translate}} {{equipment}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="equipment&&modelSummary"  @click="$router.push({path: '/modelsummary',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment:equipment}})">
                <v-list-tile-title>{{'View anomalies for'|translate}} {{equipment}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="equipment&&notificationBreakdown"  @click="$router.push({path: '/notification-breakdown',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment_name:equipment}})">
                <v-list-tile-title>{{'View notifications for'|translate}} {{equipment}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  v-if="equipment&&equipmentSummary" @click="$router.push({path: '/equipment-summary',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment:equipment}})">
                <v-list-tile-title>{{'View equipment summary for'|translate}} {{equipment}}</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: 'EquipmentContextMenu',
        props: {
            equipment: {type: String, default:null},
            dateRange: {type: Object, default:null},
            fault: {type: Boolean, default:false},
            modelSummary: {type: Boolean, default:false},
            notificationBreakdown: {type: Boolean, default:false},
            equipmentSummary: {type: Boolean, default:false},
        }
    }
</script>